import React, { ChangeEvent, useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { PATTERNS } from "../../util/patterns";
import "../Assets/css/landing-pages-main.scss";

const LoginForm = () => {
    const [email, setEmailInput] = useState("");

    const { register, errors, handleSubmit } = useForm({
        mode: "onBlur",
        reValidateMode: "onBlur",
    });

    const history = useHistory();

    const handleEmailInput = (event: ChangeEvent<HTMLInputElement>) => {
        setEmailInput(event.target.value);
    };
    const onSubmit = (data: any) => {
        history.push(`/Login?Email=${email}`);
    };

    const handleClick = () => {
        handleSubmit(onSubmit);
        window.addToDataLayer({ event: "PartnerHomeLogin Continue" });
    }
    return (
        <React.Fragment>
            <div>
                <label htmlFor="emailId">
                    User ID (Email)
                    <span className="required" title="Mandatory">
                        {" "}
                        *
                    </span>
                </label>
            </div>

            <form onSubmit={handleSubmit(onSubmit)} id="login-form">
                <div className="form-input">
                    <input
                        aria-required="true"
                        name="email"
                        id="emailId"
                        type="text"
                        defaultValue={email}
                        onChange={handleEmailInput}
                        ref={register({
                            required: true,
                            pattern: PATTERNS.EMAIL.pattern,
                        })}
                        className="landing-pages textField"
                    />
                    {!!errors["email"] && errors["email"].type === "required" && (
                        <span role="alert" className="form-error">
                            User ID (Email) is Required
                        </span>
                    )}
                    {!!errors["email"] && errors["email"].type === "pattern" && (
                        <span role="alert" className="form-error">
                            Please enter your valid User ID (Email) (example: johndoe@domain.com)
                        </span>
                    )}
                </div>
                <div className="submit-container">
                    <a id="forgotPassword" href="/app/forgot-password" tabIndex={0} className="forgot-password" onClick={() => { window.addToDataLayer({ event: "PartnerHomeLogin Forgot Password" });}}>
                        Forgot Password?
                    </a>

                    <input id="btn_submit" type="submit" value="Continue" className="landing-pages-TMPL9 LogInBtn mobileButton medium" onClick={() => handleClick()} />
                </div>
            </form>
        </React.Fragment>
    );
};
export default LoginForm;
